/* Heart Attack Proof Masterclass - Aug 25 2026
   Loaded only by the Custom Liquid block on product.heart-attack-proof-8-25-26.json */
(function () {
  var root = document.querySelector('.nhd-hap');
  if (!root) return;

  /* Variant id is written onto the wrapper by Liquid in the Custom Liquid block. */
  var HAP_VARIANT_ID = parseInt(root.getAttribute('data-hap-variant'), 10) || 0;

  /* ----------------------------------------------------------------------
     RESERVE MY SEAT -> ensure exactly one seat in the cart -> checkout
     Uses change.js when the seat is already present so a repeat click or a
     back-button return never produces a quantity of 2. Other cart items are
     left alone.
  ---------------------------------------------------------------------- */
  function reserveSeat(btn) {
    if (!HAP_VARIANT_ID) {
      console.error('[NHD] Masterclass variant id missing. Check that this template is assigned to the masterclass product and that the product has an available variant.');
      return;
    }
    if (btn) { btn.disabled = true; }

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var present = cart.items.some(function (i) { return i.variant_id === HAP_VARIANT_ID; });
        var endpoint = present ? '/cart/change.js' : '/cart/add.js';
        return fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: HAP_VARIANT_ID, quantity: 1 })
        });
      })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () { window.location.href = '/checkout'; });
  }

  /* ----------------------------------------------------------------------
     COUNTDOWN — Tuesday August 25 2026, 7:00 PM ET.
     August is EDT (UTC-4), so 7:00 PM ET = 23:00 UTC. Stated in UTC so the
     countdown is correct for every visitor regardless of their timezone.
  ---------------------------------------------------------------------- */
  var TARGET = new Date("2026-08-25T23:00:00Z").getTime();
  var cdBox = root.querySelector('#hap-cd');

  function pad(n) { return String(n).padStart(2, "0"); }

  function set(key, val) {
    var el = root.querySelector('[data-cd="' + key + '"]');
    if (el) el.textContent = pad(val);
  }

  function tick() {
    var d = TARGET - Date.now();
    if (d <= 0) {
      /* Class has started. Countdown collapses to a single notice rather than
         sitting at 00:00:00:00. Buttons stay live so late buyers still get the
         replay. */
      if (cdBox && !cdBox.dataset.done) {
        cdBox.dataset.done = "1";
        cdBox.innerHTML = '<div class="cd cd-live"><b>The class is underway</b><span>Your seat still includes the replay</span></div>';
      }
      return;
    }
    set("d", Math.floor(d / 86400000));
    set("h", Math.floor(d % 86400000 / 3600000));
    set("m", Math.floor(d % 3600000 / 60000));
    set("s", Math.floor(d % 60000 / 1000));
    setTimeout(tick, 1000);
  }
  tick();

  /* ECG line draws once when it scrolls into view */
  (function () {
    var b = root.querySelector('.ecg-band');
    if (!b) return;
    if (!('IntersectionObserver' in window)) { b.classList.add('play'); return; }
    var o = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { b.classList.add('play'); o.disconnect(); } });
    }, { threshold: .35 });
    o.observe(b);
  })();

  /* Delegated click handling */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hap-reserve]');
    if (btn) {
      e.preventDefault();
      reserveSeat(btn);
    }
  });
})();

